import React, { useState, useEffect } from "react";
import {
  Button,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Icon,
  ModalCloseButton,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Select,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import {
  FaEdit,
  FaUserCog,
  FaUserTie,
  FaClock,
  FaUserFriends,
  FaUserGraduate,
  FaUsers,
  FaFingerprint,
  FaIdCard,
  FaCarSide,
  FaCar,
  FaCalendarAlt,
} from "react-icons/fa";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Bus_Edit = ({ bus_id, RefreshData }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [busDetails, setBusDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const [driverId, setDriverId] = useState("");
  const [conductorId, setConductorId] = useState("");
  const [drivers, setDrivers] = useState([]);
  const [conductors, setConductors] = useState([]);

  useEffect(() => {
    fetchStaff();
    fetchBusDetails();
  }, []);

  const fetchStaff = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/bus/staff/list_all_bus_staff.php`,
        { params: { school_id: sessionStorage.getItem("school_id") } }
      );

      if (response.data.success) {
        const driverData = response.data.data.filter(
          (staff) => staff.staff_type === "Driver"
        );
        const conductorData = response.data.data.filter(
          (staff) => staff.staff_type !== "Driver"
        );

        setDrivers(driverData);
        setConductors(conductorData);
      } else {
        console.error("Failed to fetch staff");
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      toast({
        title: "Error",
        description: "There was an issue fetching the staff data.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const fetchBusDetails = async () => {
    try {
      const schoolId = sessionStorage.getItem("school_id");
      const response = await fetch(
        `${BASE_URL}/admin/bus/vehicle/view_bus_details.php?bus_id=${bus_id}&school_id=${schoolId}`
      );

      const data = await response.json();
      console.log("Bus details:", data);

      if (data.success) {
        setBusDetails(data.data);
        setDriverId(data.data.driver_id);
        setConductorId(data.data.conductor_id);
      } else {
        toast({
          title: "Error",
          description: data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error fetching bus details:", error);
      toast({
        title: "Error",
        description: "Failed to fetch bus details.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleEdit = async () => {
    try {
      setIsLoading(true);

      const updatedBusDetails = {
        id: bus_id,
        bus_no: busDetails.bus_no,
        reg_no: busDetails.reg_no,
        vehicle_model: busDetails.vehicle_model,
        model_year: busDetails.model_year,
        chassis_no: busDetails.chassis_no,
        seat_capacity: busDetails.seat_capacity,
        min_students: busDetails.min_students,
        max_students: busDetails.max_students,
        time_from_school: busDetails.time_from_school,
        time_to_school: busDetails.time_to_school,
        driver_id: driverId,
        conductor_id: conductorId,
        school_id: sessionStorage.getItem("school_id"),
        user_id: sessionStorage.getItem("user_id"),
      };

      const response = await fetch(
        `${BASE_URL}/admin/bus/vehicle/edit_bus_details.php`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedBusDetails),
        }
      );

      const data = await response.json();
      console.log("Edit Bus Response:", data);

      if (data.success) {
        toast({
          title: "Success",
          description: data.message,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        onClose();
        RefreshData();
      } else {
        toast({
          title: "Error",
          description: data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error updating bus details:", error);
      toast({
        title: "Error",
        description: "Failed to update bus details.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBusDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const openModal = () => {
    fetchBusDetails();
    onOpen();
  };

  return (
    <>
      <IconButton
        icon={<FaEdit />}
        colorScheme="blue"
        size="sm"
        onClick={openModal}
        aria-label="Edit"
      />
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaEdit} boxSize={5} mr={2} />
            Edit Bus Details
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <SimpleGrid columns={[1, 2]} spacing={4}>
              <FormControl>
                <FormLabel>
                  <Icon as={FaCar} mr={1} color="teal.500" />
                  Vehicle No
                </FormLabel>
                <Input
                  name="bus_no"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={busDetails.bus_no || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaCarSide} mr={1} color="teal.500" />
                  Vehicle Model
                </FormLabel>
                <Input
                  name="vehicle_model"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={busDetails.vehicle_model || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaCalendarAlt} mr={1} color="teal.500" />
                  Made of Year
                </FormLabel>
                <Input
                  name="model_year"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="number"
                  value={busDetails.model_year || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaIdCard} mr={1} color="teal.500" />
                  Registration No
                </FormLabel>
                <Input
                  name="reg_no"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={busDetails.reg_no || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaFingerprint} mr={1} color="teal.500" />
                  Chassis No
                </FormLabel>
                <Input
                  name="chassis_no"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={busDetails.chassis_no || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaUsers} mr={1} color="teal.500" />
                  Seat Capacity
                </FormLabel>
                <Input
                  name="seat_capacity"
                  type="number"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={busDetails.seat_capacity || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaUserGraduate} mr={1} color="teal.500" />
                  Min Students
                </FormLabel>
                <Input
                  name="min_students"
                  type="number"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={busDetails.min_students || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaUserFriends} mr={1} color="teal.500" />
                  Max Students
                </FormLabel>
                <Input
                  name="max_students"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="number"
                  value={busDetails.max_students || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaClock} mr={1} color="teal.500" />
                  Time From School
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  name="time_from_school"
                  value={busDetails.time_from_school || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaClock} mr={1} color="teal.500" />
                  Time To School
                </FormLabel>
                <Input
                  name="time_to_school"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={busDetails.time_to_school || ""}
                  onChange={handleInputChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaUserTie} mr={1} color="teal.500" />
                  Select Driver
                </FormLabel>
                <Select
                  placeholder="Select Driver"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={driverId}
                  onChange={(e) => setDriverId(e.target.value)}
                >
                  {drivers.map((driver) => (
                    <option key={driver.id} value={driver.id}>
                      {driver.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl>
                <FormLabel>
                  <Icon as={FaUserCog} mr={1} color="teal.500" />
                  Select Conductor
                </FormLabel>
                <Select
                  placeholder="Select Conductor"
                  value={conductorId}
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  onChange={(e) => setConductorId(e.target.value)}
                >
                  {conductors.map((conductor) => (
                    <option key={conductor.id} value={conductor.id}>
                      {conductor.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </SimpleGrid>
          </ModalBody>
          <ModalFooter>
            {/* <Button onClick={onClose} mr={3}>
              Cancel
            </Button> */}
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              isLoading={isLoading}
              onClick={handleEdit}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Bus_Edit;
